import React from 'react';

import Modal from 'js/src/components/common/ui/modal';

type Props = {
    showing: boolean;
};

const WebGlSupportMissingModal = React.memo(function WebGlSupportMissingModal({ showing }: Props) {
    const onClick = React.useCallback(() => {
        analytics.track('Clicked webgl not supported instruction');
    }, []);
    return (
        <Modal showing={showing} title="Uh oh!" closeable={false}>
            <h2>WebGL Support Missing</h2>
            <p>
                It looks like you can&apos;t use Lumen5 right now because you don&apos;t have WebGL
                support.
            </p>
            <p>
                Click&nbsp;
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="//help.lumen5.com/en/article/what-is-webgl-and-why-do-i-need-it-for-lumen5-fapsnn/"
                    onClick={onClick}
                >
                    here
                </a>{' '}
                to find out how you can fix this.
            </p>
        </Modal>
    );
});

export default WebGlSupportMissingModal;
